
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Thirtinseaterurbania() {



    const cardData =
    {
        keyword: ' 13 seater force urbania on Rent in Pune',
        heading: 'Samarth Travels:  13 seater force urbania on Rent in Pune',
        headingDescription: 'Samarth Travels offers 13 Seater Force Urbania on rent in Pune, ideal for family trips, group tours, corporate outings, and outstation journeys. Our well-maintained 13-seater Force Urbania vehicles come with air-conditioning, push-back seats, and spacious interiors to ensure a comfortable and relaxing travel experience. With professional drivers, clear pricing, and dependable service, Samarth Travels delivers a smooth and enjoyable ride every time.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

"services": [
    {
        "name": "13 Seater Force Urbania on Rent in Pune",
        "description": "Samarth Travels offers a 13-seater Force Urbania on rent in Pune, providing a comfortable and reliable travel solution for medium-sized groups. Ideal for family trips, group outings, or corporate events, our well-maintained vehicles ensure that everyone can travel together in style and comfort."
    },
    {
        "name": "Rent 13-Seater Force Urbania in Pune",
        "description": "Need a vehicle for a small group trip? Rent a 13-seater Force Urbania from Samarth Travels in Pune. With ample space, air-conditioning, and comfortable seating, it’s perfect for family vacations, business outings, and sightseeing tours. We offer flexible rental packages tailored to your needs."
    },
    {
        "name": "Force Urbania 13-Seater Rental Pune",
        "description": "Samarth Travels provides premium 13-seater Force Urbania rentals in Pune. Whether it’s for an outstation trip, corporate conference, or a special family event, our rentals offer luxury, comfort, and reliable service. Book your 13-seater Urbania today for a seamless travel experience."
    },
    {
        "name": "13-Seater Force Urbania for Family Trips Pune",
        "description": "Make family travel more enjoyable with our 13-seater Force Urbania rentals in Pune. Whether it’s a weekend getaway, a holiday to nearby hill stations, or an extended family vacation, our vehicles provide ample space for all family members, with air-conditioning and comfortable seating for a relaxed journey."
    },
    {
        "name": "Force Urbania 13-Seater for Corporate Events Pune",
        "description": "Need transportation for your corporate event in Pune? Rent the 13-seater Force Urbania for a comfortable ride to seminars, workshops, or team-building events. Our professional chauffeurs and well-maintained vehicles ensure that your corporate transportation is smooth, punctual, and efficient."
    },
    {
        "name": "Rent Force Urbania 13-Seater for Group Outings",
        "description": "Planning a group outing in Pune? Rent a 13-seater Force Urbania for your next adventure. Whether it's a day trip, sports event, or college tour, our vans provide spacious seating and plenty of room for all your belongings. Travel together in comfort with Samarth Travels."
    },
    {
        "name": "13-Seater Force Urbania on Rent for Local Sightseeing",
        "description": "Explore Pune and its surrounding areas with our 13-seater Force Urbania on rent. Our vehicles are perfect for sightseeing tours, with enough space for a group of friends or family to travel together. Our drivers are familiar with local attractions, ensuring a smooth, informative, and enjoyable tour."
    },
    {
        "name": "Rent Force Urbania 13-Seater for Picnics Pune",
        "description": "Heading out for a picnic? Rent a 13-seater Force Urbania from Samarth Travels for a comfortable and enjoyable day trip. Perfect for friends, school outings, or corporate teams, this vehicle has ample space for picnic baskets, bags, and supplies, ensuring your trip starts and ends smoothly."
    },
    {
        "name": "13-Seater Force Urbania Rental Services Pune",
        "description": "Samarth Travels offers 13-seater Force Urbania rental services in Pune for a variety of occasions. Whether you need transportation for a family gathering, group trip, or corporate event, our rental services are affordable, reliable, and offer flexibility to suit your needs."
    },
    {
        "name": "Rent Force Urbania 13-Seater for Airport Transfers",
        "description": "Book a 13-seater Force Urbania for your airport transfers in Pune. Whether you're arriving or departing, our rental service ensures timely, comfortable, and safe transportation for your group. Our experienced drivers will ensure a hassle-free ride to and from Pune International Airport."
    }
],
"tableData": [
    ["13 Seater Force Urbania on Rent in Pune", "Rent 13-Seater Force Urbania in Pune"],
    ["Force Urbania 13-Seater Rental Pune", "13-Seater Force Urbania for Family Trips Pune"],
    ["Force Urbania 13-Seater for Corporate Events Pune", "Rent Force Urbania 13-Seater for Group Outings"],
    ["13-Seater Force Urbania on Rent for Local Sightseeing", "Rent Force Urbania 13-Seater for Picnics Pune"],
    ["13-Seater Force Urbania Rental Services Pune", "Rent Force Urbania 13-Seater for Airport Transfers"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable 13-Seater Force Urbania Rental Service in Pune",
        "WhyChoosedescription": "We offer trusted and professional 13-seater Force Urbania van rentals in Pune. Ideal for small group trips, corporate outings, family events, or school functions, our vans ensure a smooth and comfortable journey with experienced and courteous drivers."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious 13-Seater Force Urbania Vans",
        "WhyChoosedescription": "Our 13-seater Force Urbania vans are designed to offer comfort and ample space for your group. With comfortable seating, air-conditioning, and enough legroom, every passenger can enjoy a relaxed ride, whether it’s for a short trip or a long journey."
    },
    {
        "WhyChooseheading": "Professional Drivers for Safe and Efficient Travel",
        "WhyChoosedescription": "Our drivers are highly skilled and familiar with the roads in Pune and surrounding areas, ensuring a safe, punctual, and hassle-free trip. They prioritize passenger comfort and safety throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for 13-Seater Rentals",
        "WhyChoosedescription": "We offer affordable and transparent pricing for our 13-seater Force Urbania rentals, with no hidden charges. Whether you need the van for a few hours or an entire day, our flexible rental packages make sure you get the best value for your trip."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Travel Convenience",
        "WhyChoosedescription": "Our 13-seater Force Urbania vans are available around the clock, giving you the flexibility to plan your trip at any time. Whether you're planning an early morning journey or a late-night return, we ensure reliable transportation for all your needs."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Smooth Travel",
        "WhyChoosedescription": "Booking your 13-seater Force Urbania rental in Pune is simple and hassle-free. Once confirmed, you’ll receive real-time tracking, driver contact information, and updates on van arrivals, ensuring smooth coordination throughout your journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained 13-Seater Vans for Safety",
        "WhyChoosedescription": "We maintain the highest standards of cleanliness and safety for our 13-seater Force Urbania vans. Each van is thoroughly sanitized before every trip, ensuring a safe, hygienic environment for all passengers."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Convenient Booking",
        "WhyChoosedescription": "We provide multiple payment methods, including UPI, credit/debit cards, digital wallets, and cash, allowing you to easily and securely complete your booking without any hassle."
    }
]
























    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a 13-seater Force Urbania in Pune with Samarth Travels?',
        answer: 'Renting a 13-seater Force Urbania in Pune is simple with Samarth Travels. You can easily book the vehicle through our website or by calling our customer support. Share your trip details, such as the date, number of passengers, and pickup location, and we’ll arrange the best vehicle for your needs.',
    },
    {
        id: 2,
        question: 'What amenities are available in the 13-seater Force Urbania?',
        answer: 'The 13-seater Force Urbania is equipped with luxurious recliner seats, air conditioning, ample luggage space, reading lights, and USB charging ports. It is ideal for small groups or family trips looking for comfort and convenience.',
    },
    {
        id: 3,
        question: 'What are the rental rates for a 13-seater Force Urbania in Pune?',
        answer: 'Rental charges for a 13-seater Force Urbania in Pune start from ₹35/km. We also offer local packages, such as 4 hours/35 km and 8 hours/80 km, along with outstation rental options at competitive prices.',
    },
    {
        id: 4,
        question: 'Is the 13-seater Force Urbania suitable for long-distance travel?',
        answer: 'Yes, the 13-seater Force Urbania is perfect for long-distance travel. It offers comfortable seating, air conditioning, and plenty of space for both passengers and luggage, ensuring a smooth and relaxing journey, even for longer trips.',
    },
    {
        id: 5,
        question: 'Can I customize my pickup and drop-off locations for the 13-seater Force Urbania?',
        answer: 'Yes, we offer complete flexibility to customize your pickup and drop-off locations. Whether you need a specific location in Pune or have a unique travel plan, we will accommodate your needs for a smooth experience.',
    },
    {
        id: 6,
        question: 'Does the 13-seater Force Urbania rental include a driver and fuel?',
        answer: 'Yes, all our 13-seater Force Urbania rentals include a professional driver and fuel. Any additional charges such as tolls, parking fees, or permits will be communicated upfront for full transparency.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for 13-seater Force Urbania rentals?',
        answer: 'Yes, Samarth Travels offers 24/7 customer support for all rentals, including the 13-seater Force Urbania. If you need assistance with booking, changes in your travel plan, or have any queries, our team is available round-the-clock to help.',
    },
];

const testimonials = [
    {
        name: 'Mr. Manoj Shah',
        role: 'Corporate Executive',
        text: 'We hired a 13-seater Force Urbania for a team trip from Pune to Lonavala. The van was comfortable, spacious, and equipped with all the necessary amenities. The driver was friendly and made the trip enjoyable. I would definitely recommend Samarth Travels.',
        image: '/img/testimonial/testi_urbania_manoj.jpg',
    },
    {
        name: 'Ms. Sanya Kapoor',
        role: 'Event Coordinator',
        text: 'Booked a 13-seater Force Urbania for a family reunion trip from Pune. The van was clean, spacious, and had excellent air conditioning. The entire journey was comfortable, and our family had a great time. Thanks to Samarth Travels for a wonderful experience.',
        image: '/img/testimonial/testi_urbania_sanya.jpg',
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Force Urbania on Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/13-seater-force-urbania-on-rent-pune.jpg",
  "description": "Rent a 13-seater Force Urbania in Pune for family trips, corporate events, group outings, local sightseeing, picnics, and airport transfers. A comfortable and luxury vehicle for all your group transportation needs.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "35000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/13-seater-force-urbania-on-rent-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>13 Seater Force Urbania on Rent in Pune | Rent Force Urbania for Family & Group Travel | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a 13-seater Force Urbania in Pune for family trips, corporate events, group outings, local sightseeing, picnics, and airport transfers. Comfortable and luxury vehicle for all your group transportation needs." 
  />
  <meta 
    name="keywords" 
    content="13 Seater Force Urbania on rent in Pune, Rent 13-seater Force Urbania in Pune, Force Urbania 13-seater rental Pune, 13-seater Force Urbania for family trips Pune, Force Urbania 13-seater for corporate events Pune, Rent Force Urbania 13-seater for group outings, 13-seater Force Urbania on rent for local sightseeing, Rent Force Urbania 13-seater for picnics Pune, 13-seater Force Urbania rental services Pune, Rent Force Urbania 13-seater for airport transfers" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thirtinseaterurbania;